import { NavItem } from "common/ui-components/index";
import { NavBarNavItemProps } from "layout/nav-bar/components/navbar-nav-item.types";
import { NavMenuButton } from "layout/nav-bar/components/NavMenuButton";
import { navBarActionButtonStyles } from "layout/nav-bar/nav-bar.styles";
import { FC } from "react";
import { Link, useLocation, useMatch } from "react-router-dom";

import { ActionButton, useTheme } from "@bps/fluent-ui";

export const NavBarNavItem: FC<NavBarNavItemProps> = ({
  text,
  pathMatch,
  iconName,
  collapse,
  ...props
}) => {
  const theme = useTheme();

  const location = useLocation();

  const { items, to } =
    "items" in props
      ? { items: props.items, to: undefined }
      : { to: props.to, items: undefined };

  const active = !!useMatch(to ?? "");
  const tabMatch =
    location.pathname?.split("/")[1] === to?.toString().split("/")[1];

  const isCurrent = pathMatch ? active : tabMatch;

  return (
    <NavItem to={to ?? ""}>
      {({ to }) => (
        <Link to={to}>
          {items ? (
            <NavMenuButton
              items={items}
              text={text}
              isCurrent={isCurrent}
              iconName={iconName}
            />
          ) : (
            <ActionButton
              text={text}
              iconProps={{ iconName }}
              styles={navBarActionButtonStyles(theme, isCurrent, collapse)}
            />
          )}
        </Link>
      )}
    </NavItem>
  );
};
